import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import type { FC } from 'react'
import { styles } from './styles'

export const LoaderBox: FC = () => {
  return (
    <Box sx={styles.root}>
      <Box sx={{ width: 300 }}>
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation={false} />
      </Box>
    </Box>
  )
}
